// Yofis — контракт API `yofis.v1`. Ошибки.
//
// Ошибка на проводе — стандартная ошибка Connect (код + сообщение) с деталью
// `google.rpc.ErrorInfo { reason, domain: "yofis.ru", metadata }` (§4 документа 12).
// `ErrorInfo.reason` — имя значения `ErrorReason` без префикса `ERROR_REASON_`
// (например `INVALID_CREDENTIALS`); клиент локализует текст сам по `reason`,
// текст в ошибке Connect — служебный, для логов. Разбор строки в enum — одна функция в каждом ядре.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/errors.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file yofis/v1/errors.proto.
 */
export const file_yofis_v1_errors: GenFile = /*@__PURE__*/
  fileDesc("ChV5b2Zpcy92MS9lcnJvcnMucHJvdG8SCHlvZmlzLnYxKqsICgtFcnJvclJlYXNvbhIcChhFUlJPUl9SRUFTT05fVU5TUEVDSUZJRUQQABIkCiBFUlJPUl9SRUFTT05fSU5WQUxJRF9DUkVERU5USUFMUxABEiAKHEVSUk9SX1JFQVNPTl9TRVNTSU9OX0VYUElSRUQQAhIgChxFUlJPUl9SRUFTT05fU0VTU0lPTl9SRVZPS0VEEAMSIgoeRVJST1JfUkVBU09OX1NJR05BVFVSRV9NSVNTSU5HEAQSIgoeRVJST1JfUkVBU09OX1NJR05BVFVSRV9JTlZBTElEEAUSKAokRVJST1JfUkVBU09OX1RJTUVTVEFNUF9PVVRfT0ZfV0lORE9XEAYSHQoZRVJST1JfUkVBU09OX05PTkNFX1JFUExBWRAHEh8KG0VSUk9SX1JFQVNPTl9ERVZJQ0VfUkVWT0tFRBAIEiAKHEVSUk9SX1JFQVNPTl9ERVZJQ0VfTUlTTUFUQ0gQCRIdChlFUlJPUl9SRUFTT05fTUZBX1JFUVVJUkVEEAoSIQodRVJST1JfUkVBU09OX1VTRVJfREVBQ1RJVkFURUQQCxIdChlFUlJPUl9SRUFTT05fVVNFUl9CTE9DS0VEEAwSIAocRVJST1JfUkVBU09OX0JMT0NLRURfQllfUEVFUhANEhsKF0VSUk9SX1JFQVNPTl9OT1RfTUVNQkVSEA4SHgoaRVJST1JfUkVBU09OX1JPTEVfUkVRVUlSRUQQDxIjCh9FUlJPUl9SRUFTT05fUE9TVElOR19SRVNUUklDVEVEEBASHQoZRVJST1JfUkVBU09OX0xJTktfRVhQSVJFRBAREh0KGUVSUk9SX1JFQVNPTl9MSU5LX1JFVk9LRUQQEhIfChtFUlJPUl9SRUFTT05fTElOS19FWEhBVVNURUQQExIfChtFUlJPUl9SRUFTT05fTE9CQllfUkVRVUlSRUQQFBIeChpFUlJPUl9SRUFTT05fTE9CQllfUEVORElORxAVEiAKHEVSUk9SX1JFQVNPTl9HVUVTVFNfRElTQUJMRUQQFhIhCh1FUlJPUl9SRUFTT05fTUVTU0FHRV9UT09fTE9ORxAXEh8KG0VSUk9SX1JFQVNPTl9GSUxFX1RPT19MQVJHRRAYEiEKHUVSUk9SX1JFQVNPTl9VTlNVUFBPUlRFRF9NSU1FEBkSJQohRVJST1JfUkVBU09OX1RPT19NQU5ZX0FUVEFDSE1FTlRTEBoSHQoZRVJST1JfUkVBU09OX1JBVEVfTElNSVRFRBAbEh8KG0VSUk9SX1JFQVNPTl9DVVJTT1JfRVhQSVJFRBAcEiQKIEVSUk9SX1JFQVNPTl9DQVBBQklMSVRZX0RJU0FCTEVEEB0SJQohRVJST1JfUkVBU09OX0lERU1QT1RFTkNZX0NPTkZMSUNUEB5CRQoRcnUueW9maXMucHJvdG8udjFQAVomeW9maXMucnUveW9maXMvZ2VuL2dvL3lvZmlzL3YxO3lvZmlzdjG6AgVZb2Zpc2IGcHJvdG8z");

/**
 * Фиксированный список причин ошибок. Рядом с каждой — код Connect, с которым она приходит.
 * Список только расширяется; клиент неизвестную причину показывает по коду Connect.
 *
 * @generated from enum yofis.v1.ErrorReason
 */
export enum ErrorReason {
  /**
   * Не задана (ошибка без `ErrorInfo` — клиент действует по коду Connect).
   *
   * @generated from enum value: ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * unauthenticated: неверный логин или пароль.
   *
   * @generated from enum value: ERROR_REASON_INVALID_CREDENTIALS = 1;
   */
  INVALID_CREDENTIALS = 1,

  /**
   * unauthenticated: сессия истекла — клиент на экран входа.
   *
   * @generated from enum value: ERROR_REASON_SESSION_EXPIRED = 2;
   */
  SESSION_EXPIRED = 2,

  /**
   * unauthenticated: сессия отозвана (пользователем, админом, «выйти везде») — клиент на экран входа.
   *
   * @generated from enum value: ERROR_REASON_SESSION_REVOKED = 3;
   */
  SESSION_REVOKED = 3,

  /**
   * unauthenticated: у подписанного метода нет заголовков подписи (ADR-005).
   *
   * @generated from enum value: ERROR_REASON_SIGNATURE_MISSING = 4;
   */
  SIGNATURE_MISSING = 4,

  /**
   * unauthenticated: подпись не сошлась.
   *
   * @generated from enum value: ERROR_REASON_SIGNATURE_INVALID = 5;
   */
  SIGNATURE_INVALID = 5,

  /**
   * unauthenticated: `X-Yofis-Timestamp` вне окна ±300 с — клиенту стоит проверить часы.
   *
   * @generated from enum value: ERROR_REASON_TIMESTAMP_OUT_OF_WINDOW = 6;
   */
  TIMESTAMP_OUT_OF_WINDOW = 6,

  /**
   * unauthenticated: `X-Yofis-Nonce` уже использовался (окно 5 минут).
   *
   * @generated from enum value: ERROR_REASON_NONCE_REPLAY = 7;
   */
  NONCE_REPLAY = 7,

  /**
   * unauthenticated: устройство отозвано — клиент разлогинивается и чистит ключи.
   *
   * @generated from enum value: ERROR_REASON_DEVICE_REVOKED = 8;
   */
  DEVICE_REVOKED = 8,

  /**
   * unauthenticated: `X-Yofis-Device` не совпадает с устройством сессии.
   *
   * @generated from enum value: ERROR_REASON_DEVICE_MISMATCH = 9;
   */
  DEVICE_MISMATCH = 9,

  /**
   * failed_precondition: требуется второй фактор (закладка).
   *
   * @generated from enum value: ERROR_REASON_MFA_REQUIRED = 10;
   */
  MFA_REQUIRED = 10,

  /**
   * permission_denied: пользователь деактивирован.
   *
   * @generated from enum value: ERROR_REASON_USER_DEACTIVATED = 11;
   */
  USER_DEACTIVATED = 11,

  /**
   * permission_denied: вы заблокировали этого пользователя.
   *
   * @generated from enum value: ERROR_REASON_USER_BLOCKED = 12;
   */
  USER_BLOCKED = 12,

  /**
   * permission_denied: собеседник заблокировал вас.
   *
   * @generated from enum value: ERROR_REASON_BLOCKED_BY_PEER = 13;
   */
  BLOCKED_BY_PEER = 13,

  /**
   * permission_denied: вы не участник чата.
   *
   * @generated from enum value: ERROR_REASON_NOT_MEMBER = 14;
   */
  NOT_MEMBER = 14,

  /**
   * permission_denied: нужна роль выше (ADMIN/OWNER чата или узла).
   *
   * @generated from enum value: ERROR_REASON_ROLE_REQUIRED = 15;
   */
  ROLE_REQUIRED = 15,

  /**
   * permission_denied: в этом чате писать могут только администраторы (`ChatSettings.only_admins_post`).
   *
   * @generated from enum value: ERROR_REASON_POSTING_RESTRICTED = 16;
   */
  POSTING_RESTRICTED = 16,

  /**
   * failed_precondition: срок ссылки-права истёк.
   *
   * @generated from enum value: ERROR_REASON_LINK_EXPIRED = 17;
   */
  LINK_EXPIRED = 17,

  /**
   * failed_precondition: ссылка отозвана.
   *
   * @generated from enum value: ERROR_REASON_LINK_REVOKED = 18;
   */
  LINK_REVOKED = 18,

  /**
   * failed_precondition: исчерпан лимит использований ссылки.
   *
   * @generated from enum value: ERROR_REASON_LINK_EXHAUSTED = 19;
   */
  LINK_EXHAUSTED = 19,

  /**
   * failed_precondition: вход только через лобби — используйте `LinkService.JoinByLink` и ждите `LobbyUpdated`.
   *
   * @generated from enum value: ERROR_REASON_LOBBY_REQUIRED = 20;
   */
  LOBBY_REQUIRED = 20,

  /**
   * failed_precondition: заявка в лобби ещё не рассмотрена.
   *
   * @generated from enum value: ERROR_REASON_LOBBY_PENDING = 21;
   */
  LOBBY_PENDING = 21,

  /**
   * failed_precondition: гости на узле выключены (`NodeSettings.guests_enabled`).
   *
   * @generated from enum value: ERROR_REASON_GUESTS_DISABLED = 22;
   */
  GUESTS_DISABLED = 22,

  /**
   * invalid_argument: текст длиннее `Limits.max_message_chars`.
   *
   * @generated from enum value: ERROR_REASON_MESSAGE_TOO_LONG = 23;
   */
  MESSAGE_TOO_LONG = 23,

  /**
   * invalid_argument: файл больше `Limits.max_file_bytes`.
   *
   * @generated from enum value: ERROR_REASON_FILE_TOO_LARGE = 24;
   */
  FILE_TOO_LARGE = 24,

  /**
   * invalid_argument: MIME-тип не принимается узлом.
   *
   * @generated from enum value: ERROR_REASON_UNSUPPORTED_MIME = 25;
   */
  UNSUPPORTED_MIME = 25,

  /**
   * invalid_argument: вложений больше `Limits.max_attachments`.
   *
   * @generated from enum value: ERROR_REASON_TOO_MANY_ATTACHMENTS = 26;
   */
  TOO_MANY_ATTACHMENTS = 26,

  /**
   * resource_exhausted: превышен лимит запросов; в метаданных `ErrorInfo` и заголовке ответа — `retry-after` (секунды).
   *
   * @generated from enum value: ERROR_REASON_RATE_LIMITED = 27;
   */
  RATE_LIMITED = 27,

  /**
   * failed_precondition: курсор стрима или пагинации устарел — нужен ресинк (ListChats + GetMessages(latest)).
   *
   * @generated from enum value: ERROR_REASON_CURSOR_EXPIRED = 28;
   */
  CURSOR_EXPIRED = 28,

  /**
   * unimplemented: узел не поддерживает возможность (см. `Capabilities`): звонки, гости, опросы…
   *
   * @generated from enum value: ERROR_REASON_CAPABILITY_DISABLED = 29;
   */
  CAPABILITY_DISABLED = 29,

  /**
   * already_exists: тот же `idempotency_key` / `client_msg_id` с другими параметрами.
   *
   * @generated from enum value: ERROR_REASON_IDEMPOTENCY_CONFLICT = 30;
   */
  IDEMPOTENCY_CONFLICT = 30,
}

/**
 * Describes the enum yofis.v1.ErrorReason.
 */
export const ErrorReasonSchema: GenEnum<ErrorReason> = /*@__PURE__*/
  enumDesc(file_yofis_v1_errors, 0);

